const { inRn } = require('lib/helpers/utility');

const getTableParams = (searchParams, paramPrefix) => {
  const view = searchParams.get('view');

  const getParam = (key, fallback = null) =>
    searchParams.get(paramPrefix ? `${paramPrefix}_${key}` : key) ?? fallback;

  const page = inRn(getParam('page', 1));
  const sort = getParam('sort');
  const order = getParam('order');
  const sortField = sort ? { field: sort, sort: order || 'asc' } : null;

  return { page, sortField, view, sort, order };
};

export default getTableParams;
